export const AIChatViolet = {
    // 模块配置
    // AIChat - banner
    "--theme-AIChat-banner-title-color": "#463699",
    "--theme-AIChat-banner-des-color": "#202021",
    "--theme-AIChat-banner-btn-color": "white",
    "--theme-AIChat-banner-btn-bg": "#463699",
    // AIChat - explain
    "--theme-AIChat-explain-bg": "white",
    "--theme-AIChat-explain-inner-bg": "white",
    "--theme-AIChat-explain-item-shadow": "none",
    "--theme-AIChat-explain-inner-bg-hover": "#17A18A",
    // AIChat - step
    "--theme-AIChat-step-bg": "#F6F6F6",
    "--theme-AIChat-step-inner-bg": "#252325",
    "--theme-AIChat-step-inner-bg-hover": "#463699",
    "--theme-AIChat-step-title-color": "#111212",
    "--theme-AIChat-step-inner-title-color": "white",
    "--theme-AIChat-step-inner-desc-color": "white",
    "--theme-AIChat-step-inner-title-color-hover": "white",
    "--theme-AIChat-step-inner-desc-color-hover": "white",
    "--theme-AIChat-step-radius": "0px",
    // AIChat - price
    "--theme-AIChat-price-btn-bg": "#FF4867",
    "--theme-AIChat-price-btn-bg-hover": "#FF4867",
    "--theme-AIChat-price-btn-color": "#252325",
    "--theme-AIChat-price-btn-color-hover": "#252325",
    "--theme-AIChat-price-text-color": "#252325",
    "--theme-AIChat-price-text-color-hover": "#FF4867",
    "--theme-AIChat-price-ul-text-align": "center",
    "--theme-AIChat-price-item-bg": "#F2F2F2",
    "--theme-AIChat-price-item-bg-hover": "#463699",
    "--theme-AIChat-price-item-border-radius": "0px",
    "--theme-AIChat-price-light": "#5E4CB7",
    "--theme-AIChat-price-deep": "#5E4CB7",
    // AIChat - question
    "--theme-AIChat-question-bg": "#F6F6F6",
    // AIChat - comment
    "--theme-AIChat-comment-border-radius": "0px",
    "--theme-AIChat-comment-item-bg-hover": "#463699",
   
   }